import { useCallback } from 'react';
import { useHistory } from 'react-router';

import { useApplicationRootUrl } from 'common/component/ApplicationRootContext';


export function useGoToReferralListPage() {
    const history = useHistory();
    const rootUrl = useApplicationRootUrl();

    return useCallback(
        () => {
            history.push(`${rootUrl}/referral`);
        },
        [history, rootUrl]
    );
}
